// Типы <input>, в которые печатают текст (Enter и пробел там — часть набора)
const TEXT_INPUT_TYPES = new Set(['text', 'search', 'email', 'password', 'tel', 'url', 'number']);

/**
 * Событие клавиатуры пришло из поля, где человек набирает текст: textarea,
 * текстовый input или contenteditable. Глобальные горячие клавиши (например,
 * закрытие модалки по Enter и пробелу) такие нажатия пропускают — иначе
 * пробел в сообщении чата закрывал бы модалку и не печатался.
 */
export const checkIfTextEntryTarget = (target) => {
  if (!target || typeof target !== 'object') {
    return false;
  }
  if (target.isContentEditable) {
    return true;
  }
  const tagName = String(target.tagName || '').toUpperCase();
  if (tagName === 'TEXTAREA') {
    return true;
  }
  if (tagName === 'INPUT') {
    return TEXT_INPUT_TYPES.has(String(target.type || 'text').toLowerCase());
  }
  return false;
};
